import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OutsideClickModule } from 'app/shared/click/ls-outside-click.module';
import { DynamicTranslationModule } from '../../../../dynamic-translation/dynamic-translation.module';
import { LsSingleSelectComponent } from './ls-single-select.component';
import { LsSingleTooltipSelectComponent } from './ls-single-tooltip-select/ls-single-tooltip-select.component';
import { SelectLargeDirective } from './select-large.directive';
import { SelectSmallDirective } from './select-small.directive';
import { LsFormSingleSelectComponent } from './ls-form-single-select.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    OutsideClickModule,
    DynamicTranslationModule,
    ReactiveFormsModule
  ],
  declarations: [
    LsSingleSelectComponent,
    LsFormSingleSelectComponent,
    LsSingleTooltipSelectComponent,
    SelectLargeDirective,
    SelectSmallDirective
  ],
  exports: [
    LsSingleSelectComponent,
    LsFormSingleSelectComponent,
    LsSingleTooltipSelectComponent,
    SelectLargeDirective,
    SelectSmallDirective
  ]
})
export class LsSingleSelectModule {}
